/** @format */

import React, { useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CampaignForm } from '../components/CampaignForm';

interface CampaignFormContainerProps {
  onSuccess?: () => void;
}

/**
 * Container for CampaignForm
 * Manages modal visibility and form submission
 */
export const CampaignFormContainer: React.FC<CampaignFormContainerProps> = ({ onSuccess }) => {
  const [visible, setVisible] = useState(false);

  const handleOpen = () => {
    setVisible(true);
  };

  const handleClose = () => {
    setVisible(false);
  };

  const handleSuccess = () => {
    onSuccess?.();
    handleClose();
  };

  return (
    <>
      <Button type='primary' icon={<PlusOutlined />} onClick={handleOpen}>
        Add Campaign
      </Button>
      {visible && (
        <CampaignForm visible={visible} onCancel={handleClose} onSuccess={handleSuccess} />
      )}
    </>
  );
};

export default CampaignFormContainer;
